import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LanguageProvider } from './i18n/context';
import './styles/global.css';
import { registerSW } from 'virtual:pwa-register';

/**
 * PWA 更新:
 * - 新しい SW を検知したら自動適用（ホーム画面アプリも次回起動/このリロードで新版）
 * - localStorage のチェック履歴・ユーザーデータは消さない（キャッシュ掃除のみ）
 */
const updateSW = registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    const ping = () => {
      void registration.update();
    };
    ping();
    window.setInterval(ping, 60 * 60 * 1000);
    window.addEventListener('focus', ping);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') ping();
    });
  },
  onNeedRefresh() {
    // 履歴（localStorage）は維持したままアセットだけ差し替える
    void updateSW(true);
  },
  onOfflineReady() {
    // no-op
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
